module.exports = __webpack_public_path__ + "img/fottom-full-logo.036d2c85.svg";